//Module comprises the metadata (sync rules) for the settings of the RelatedApps button at ObjectPageHeaderActions
import type { v4 } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { getAdditionalSemanticObjectPath, getSettingsPathForPage } from '../../application';

export class AdditionalSemanticObject implements v4.AdditionalSemanticObject {
    @syncRule({
        manifest: {
            path: getAdditionalSemanticObjectPath
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/sdk/#/topic/8dcfe2e4555f49db8859cb6eb838692e')
    @validity({
        since: '1.108.0'
    })
    allowedActions?: string[];

    @syncRule({
        manifest: {
            path: getAdditionalSemanticObjectPath
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/sdk/#/topic/8dcfe2e4555f49db8859cb6eb838692e')
    @validity({
        since: '1.96.0'
    })
    unavailableActions?: string[];

    @syncRule({
        manifest: {
            path: getAdditionalSemanticObjectPath
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/sdk/#/topic/8dcfe2e4555f49db8859cb6eb838692e')
    @validity({
        since: '1.96.0'
    })
    mapping?: v4.SemanticObjectPropertyMapping;
}

export class RelatedApps implements v4.RelatedApps {
    @syncRule({
        manifest: {
            path: (pageName: string[]): string => getSettingsPathForPage(pageName)
        }
    })
    @validity({
        since: '1.84.0'
    })
    showRelatedApps?: boolean;

    @syncRule({
        manifest: {
            path: getSettingsPathForPage
        }
    })
    additionalSemanticObjects: v4.AdditionalSemanticObjects;
}
